/**
 * WhatsApp só é oferecido para usuários brasileiros: o número é normalizado
 * com DDI 55 (ver `mappers/phone.ts`) e a máscara é nacional.
 */

/**
 * Decide se o canal WhatsApp deve aparecer.
 *
 * `country` tem prioridade sobre `locale` — é o dado mais específico. Só cai
 * no `locale` quando `country` vem vazio/ausente. Se nenhum dos dois vier,
 * assume brasileiro (o público majoritário e o fallback do i18n é `pt_BR`).
 *
 * Aceita as variações que a API pode devolver: `BR`, `br`, `Brasil`, `Brazil`,
 * `pt_BR`, `pt-br`.
 */
export function isBrazilianUser(
  country?: string | null,
  locale?: string | null,
): boolean {
  const normalizedCountry = country?.trim().toLowerCase();

  if (normalizedCountry) {
    return (
      normalizedCountry === "br" ||
      normalizedCountry === "bra" ||
      normalizedCountry === "brasil" ||
      normalizedCountry === "brazil"
    );
  }

  const normalizedLocale = locale?.trim().toLowerCase().replace("-", "_");

  if (normalizedLocale) {
    return (
      normalizedLocale === "pt" ||
      normalizedLocale === "br" ||
      normalizedLocale.startsWith("pt_")
    );
  }

  // Sem informação: mantém o comportamento padrão do app (pt_BR).
  return true;
}
